import Vue from "vue";
import VueRouter from "vue-router";
Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: () => import("../views/header.vue"),
  },
  {
    path: "/enterprise",
    name: "enterprise",
    component: () => import("../views/enterprise/tablist"),
  },
  {
    path: "/entLogo",
    name: "qiyelogo",
    component: () => import("../views/enterprise/qiyelogo.vue"),
  },
  {
    path: "/tablist",
    name: "tablist",
    component: () => import("../views/tablist.vue"),
  },
  {
    path: "/tabfind",
    name: "tabfind",
    component: () => import("../views/tabfind.vue"),
  },
  {
    path: "/login",
    name: "login",
    component: () => import("../views/login.vue"),
  },
  {
    path: "/home",
    name: "main",
    component: () => import("../views/main.vue"),
    children: [
      {
        path: "/home/bulletin",
        name: "bulletin",
        component: () => import("../views/bulletin.vue"),
      },
      {
        path: "/home/barlist",
        name: "barlist",
        component: () => import("../views/barlist.vue"),
      },
      {
        path: "/home/Configuration",
        name: "Configuration",
        component: () => import("../views/Configuration.vue"),
      },
      {
        path: "/home/Advertising",
        name: "Advertising",
        component: () => import("../views/Advertising.vue"),
      },
      {
        path: "/home/Friendship",
        name: "Friendship",
        component: () => import("../views/Friendshiplink.vue"),
      },
      {
        path: "/home/tabone",
        name: "tabone",
        component: () => import("../views/tab/tabone.vue"),
      },
      {
        path: "/home/tabtwo",
        name: "tabtwo",
        component: () => import("../views/tab/tabtwo.vue"),
      },
      {
        path: "/home/tabthree",
        name: "tabthree",
        component: () => import("../views/tab/tabthree.vue"),
      },
      {
        path: "/home/tabfour",
        name: "tabfour",
        component: () => import("../views/tab/tabfour.vue"),
      },
      {
        path: "/home/tabfive",
        name: "tabfive",
        component: () => import("../views/tab/tabfive.vue"),
      },
      {
        path: "/home/tabsix",
        name: "tabsix",
        component: () => import("../views/tab/tabsix.vue"),
      },
      {
        path: "/home/tabseven",
        name: "tabseven",
        component: () => import("../views/tab/tabseven.vue"),
      },
      {
        path: "/home/tabeight",
        name: "tabeight",
        component: () => import("../views/tab/tabeight.vue"),
      },
      {
        path: "/home/tabnine",
        name: "tabnine",
        component: () => import("../views/tab/tabnine.vue"),
      },
      {
        path: "/home/tabten",
        name: "tabten",
        component: () => import("../views/tab/tabten.vue"),
      },
      {
        path: "/home/tabeleven",
        name: "tabeleven",
        component: () => import("../views/tab/tabeleven.vue"),
      },
      {
        path: "/home/tabtwelve",
        name: "tabtwelve",
        component: () => import("../views/tab/tabtwelve.vue"),
      },
      {
        path: "/home/tabthirteen",
        name: "tabthirteen",
        component: () => import("../views/tab/tabthirteen.vue"),
      },
      {
        path: "/home/tabfourteen",
        name: "tabfourteen",
        component: () => import("../views/tab/tabfourteen.vue"),
      },
      {
        path: "/home/tabfifteen",
        name: "tabfifteen",
        component: () => import("../views/tab/tabfifteen.vue"),
      },
      {
        path: "/home/user",
        name: "user",
        component: () => import("../views/user.vue"),
      },
      {
        path: "/home/menu",
        name: "menu",
        component: () => import("../views/menu.vue"),
      },
      {
        path: "/home/enterprise/index",
        name: "enterprise",
        component: () => import("../views/enterprise/index"),
      },
    ],
  },
  {
    path: "/activity",
    // 1、创建路由组件
    name: "activity",
    component: () => import("../views/active"),
  },

  {
    path: "/activitwo",
    // 1、创建路由组件
    name: "activity",
    component: () => import("../views/acitvetwo"),
  },
  {
    path: "/inquiry",
    // 1、创建路由组件
    name: "inquiry",
    component: () => import("../views/inquiry"),
  },
];

const router = new VueRouter({
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
});
router.beforeEach((to, from, next) => {
  // 判断是否登录
  if (
    to.name != "home" &&
    to.name != "login" &&
    to.name != "activity" &&
    to.name != "tablist" &&
    to.name != "tabfind" &&
    to.name != "inquiry" &&
    to.name != "enterprise" &&
    to.name != "qiyelogo"
  ) {
    if (window.sessionStorage.getItem("token") == null) {
      next("/");
    } else {
      next();
    }
  } else {
    next();
  }

  // if(sessionstorage.getItem("token") == "1") {
  //   next()
  // }else {
  //    // 如果没有登录，但是跳转登录页面也放行
  //   if(to.name == 'login') {
  //     next()
  //   }else {
  //     // 如果没有登录，也不是去登录页，就拦截，让它跳转登录页
  //     next('/login')
  //   }
  // }
});

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};
export default router;
